import React from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import type { ResultsMode } from "../../hooks/useResultsMode";

export interface ResultsModeTabsProps {
  mode: ResultsMode;
  onChange: (m: ResultsMode) => void;
  /** Hide modes that wouldn't apply (e.g. single participant) */
  available?: ResultsMode[];
}

const ResultsModeTabs: React.FC<ResultsModeTabsProps> = ({
  mode,
  onChange,
  available = ["tableau", "consensus", "engagement", "blockers"],
}) => {
  const { t } = useTranslation("polls");

  return (
    <Tabs
      value={mode}
      onValueChange={(v) => onChange(v as ResultsMode)}
      data-testid="results-mode-tabs"
    >
      <TabsList className="h-12 sm:h-10">
        {available.map((m) => (
          <TabsTrigger
            key={m}
            value={m}
            data-testid={`results-mode-${m}`}
            title={t(`results_mode_tooltips.${m}`)}
            className="min-h-[40px] sm:min-h-0 px-4 sm:px-3"
          >
            {t(`results_mode_labels.${m}`)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default ResultsModeTabs;
